import readXlsxFile, { Error as RowError } from 'read-excel-file';

export type ParseResult<T> = {
  /** The successfully parsed rows of data. */
  rows: T[];
  /** * An array of errors. Can be validation errors from 'read-excel-file' (RowError)
   * or a critical file read error (FileReadError).
   */
  errors: RowError[];
};
/**
 * A straight-forward utility to parse an Excel file from a file input.
 */

export async function parseExcelWithSchema<T extends Record<string, any>>(
  file: File,
  schema: any, // Should be Schema
  onComplete: (result: ParseResult<T>) => void,
) {
  try {
    // The library uses the schema to parse types and returns a promise
    const { rows, errors } = await readXlsxFile<T>(file, { schema });
    // Pass the parsed rows and any validation errors to your callback
    onComplete({ rows, errors });

  } catch (error: any) {
    // This catches critical errors (e.g., file is corrupt, not an Excel file)
    console.error("Critical error parsing Excel file:", error);

    // Pass the error to the callback in a consistent format
    const formattedError = {
      error: 'File Read Error',
      reason: error?.message || 'Could not read the file.',
      row: 0,
      column: "0",
    };
    onComplete({ rows: [], errors: [formattedError] });
  }
}